// Website/src/services/experiences.service.js
import { API_HELPER } from '@/helpers/api.js';

const API_ROOT_SERVICE = "Experiences";

export const experiencesService = {
  getList(input) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);
    
    const requestOptions = {
      method: 'GET',
      headers: {"Content-Type":"application/json"},
    };
    
    return API_HELPER.apiCall(url, input, requestOptions);
  },
  
  getById(id) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, id]);
    
    const requestOptions = {
      method: 'GET',
      headers: {"Content-Type":"application/json"},
    };
    
    return API_HELPER.apiCall(url, null, requestOptions);
  },
  
  // Public price per day (base or price period) and slot counts. Plain fetch on purpose: this is
  // optional data, and apiCall would send the whole page to /error on a 5xx.
  getPriceSchedule(experienceId, from, to) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, experienceId, 'price-schedule']);
    return fetch(`${url}?from=${from}&to=${to}`, { headers: { "Content-Type": "application/json" } })
      .then(response => response.ok ? response.json() : Promise.reject(response.status));
  },

  getBySlug(slug) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, slug]);
    
    const requestOptions = {
      method: 'GET',
      headers: {"Content-Type":"application/json"},
    };
    
    return API_HELPER.apiCall(url, null, requestOptions);
  }
};

